import { postersCategories, wallpaperCategories } from '../../api/categories';

export const isPosterCategory = (categoryId: number) => postersCategories.indexOf(categoryId) >= 0;
export const isWallCalendarCategory = (categoryId: number) => wallpaperCategories.indexOf(categoryId) >= 0;


